import {IPartner, PartnerResponseType} from "@/entity/partner/partner.types";

export default class Partner implements IPartner {
    id: number;
    name: string;
    phone: number;
    email: string;
    social_network: string;
    constructor(data: PartnerResponseType) {
        this.id = data.id;
        this.name = data.name;
        this.phone = data.phone;
        this.email = data.email;
        this.social_network = data.social_network;
    }
}